<template>
  <v-container id="asuulga-view" tag="section">
    <v-container>
      <v-tabs v-model="selectedTab">
        <v-tab> Xамтрагч байгууллагын бүртгэл </v-tab>
        <v-tab> Мэдээ мэдээлэл </v-tab>
        <v-tab-item>
          <Organizations></Organizations>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <OrganizationsNews></OrganizationsNews>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { get, sync } from "vuex-pathify";
import Vue from "vue";
const fb = require("@/firebaseConfig.js");
export default {
  data: () => ({
    selectedTab: 0,
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  components: {
    Organizations: () => import("./Organizations"),
    OrganizationsNews: () => import("./OrganizationsNews"),
  },
  created() {
 
  },
  methods: {},
};
</script>
<style>
#newelement {
  border-color: red;
}
</style>